import { createSlice } from '@reduxjs/toolkit';
import {
	getFolders,
	getFolder,
	getFolderStructure,
	addNewFolder,
	updateFolder,
	deleteFolder,
	uploadFiles,
	getFiles,
	updateFile,
	updateFileFavourites,
	deleteFile,
	downloadFile,
	getFileType,
	getFileTypeByCode,
	downloadImageBase64,
} from './thunk';
export const initialState = {
	folders: [],
	folder: {},
	folder_structure: [],
	folderStructureIsLoading: false,
	files: {},
	error: {},
	file: {},
	file_type: {},
	isLoadingFolder: true,
	isLoadingFiles: true,
	isLoadingImage: true,
	image_base64: null
};

const FileManagerSlice = createSlice({
	name: 'FileManager',
	initialState,
	reducer: {},
	extraReducers: builder => {
		builder.addCase(getFolders.fulfilled, (state, action) => {
			state.folders = action.payload;
			state.isLoadingFolder = false;
		});
		builder.addCase(getFolders.rejected, (state, action) => {
			state.error = action.payload;
			state.isLoadingFolder = true;
		});
		builder.addCase(getFolder.fulfilled, (state, action) => {
			state.folder = action.payload;
		});
		builder.addCase(getFolder.rejected, (state, action) => {
			state.error = action.error.message || null;
		});
		builder.addCase(getFolderStructure.pending, (state, action) => {
			state.folderStructureIsLoading = true;
		});
		builder.addCase(getFolderStructure.fulfilled, (state, action) => {
			state.folderStructureIsLoading = false;
			state.folder_structure = action.payload;
		});
		builder.addCase(getFolderStructure.rejected, (state, action) => {
			state.folderStructureIsLoading = false;
			state.error = action.error.message || null;
		});
		builder.addCase(addNewFolder.fulfilled, (state, action) => {
			state.folders.push(action.payload);
		});
		builder.addCase(addNewFolder.rejected, (state, action) => {
			state.error = action.error.message || null;
		});

		builder.addCase(updateFolder.fulfilled, (state, action) => {
			state.folders = state.folders.map(folder =>
				folder._id.toString() === action.payload._id.toString()
					? { ...folder, ...action.payload }
					: folder
			);
		});

		builder.addCase(updateFolder.rejected, (state, action) => {
			state.error = action.error.message || null;
		});

		builder.addCase(deleteFolder.fulfilled, (state, action) => {
			state.folders = state.folders.filter(
				folder => folder.id + '' !== action.payload + ''
			);
		});
		builder.addCase(deleteFolder.rejected, (state, action) => {
			state.error = action.error.message || null;
		});



		builder.addCase(getFiles.fulfilled, (state, action) => {
			state.files = action.payload;
			state.isLoadingFiles = false;
		});
		builder.addCase(getFiles.pending, (state, action) => {
			state.isLoadingFiles = false;
		});
		builder.addCase(getFiles.rejected, (state, action) => {
			state.isLoadingFiles = true;
		});


		builder.addCase(getFileTypeByCode.fulfilled, (state, action) => {
			state.file_type = action.payload;
			state.isLoadingFiles = false;
		});
		builder.addCase(getFileTypeByCode.pending, (state, action) => {
			state.isLoadingFiles = false;
		});
		builder.addCase(getFileTypeByCode.rejected, (state, action) => {
			state.isLoadingFiles = true;
		});




		builder.addCase(downloadImageBase64.fulfilled, (state, action) => {
			state.image_base64 = action.payload.image_base64;
			state.isLoadingImage = false;
		});
		builder.addCase(downloadImageBase64.pending, (state, action) => {
			state.isLoadingImage = true;
		});
		builder.addCase(downloadImageBase64.rejected, (state, action) => {
			state.isLoadingImage = false;
		});






		builder.addCase(uploadFiles.fulfilled, (state, action) => {
			state.files.data = [...state.files.data, ...action.payload];
			state.files.meta.totalCount = state.files.meta.totalCount + 1;
		});
		builder.addCase(uploadFiles.rejected, (state, action) => {
			state.error = action.error.message || null;
		});

		builder.addCase(downloadFile.fulfilled, (state, action) => {
			state.file = window.URL.createObjectURL(action.payload);
		});
		builder.addCase(downloadFile.rejected, (state, action) => {
			state.error = action.error.message || null;
		});

		builder.addCase(updateFile.fulfilled, (state, action) => {
			state.files = state.files.data.map(file =>
				file._id.toString() === action.payload._id.toString()
					? { ...file, ...action.payload }
					: file
			);
		});

		builder.addCase(updateFile.rejected, (state, action) => {
			state.error = action.error.message || null;
		});

		builder.addCase(updateFileFavourites.fulfilled, (state, action) => {
			state.files = state.files.data.map(file =>
				file._id.toString() === action.payload._id.toString()
					? { ...file, ...action.payload }
					: file
			);
		});

		builder.addCase(updateFileFavourites.rejected, (state, action) => {
			state.error = action.error.message || null;
		});
		// builder.addCase(deleteFile.fulfilled, (state, action) => {
		// 	state.files = state.files.data.filter(
		// 		file => file.id + '' !== action.payload + ''
		// 	);
		// });

		builder.addCase(deleteFile.fulfilled, (state, action) => {
			// También validamos que action.payload no sea null/undefined
			if (action.payload === null || action.payload === undefined) { 
				return;
			}

			// Verifica que state.files existe y tiene la propiedad data
			if (!state.files || !Array.isArray(state.files.data)) { 
				return; // Salir temprano si no es válido
			}

			// Convertimos ambos IDs a string para la comparación
			const payloadId = String(action.payload);

			state.files.data = state.files.data.filter(
				file => file && file.id !== undefined && String(file.id) !== payloadId
			);
		});


		builder.addCase(deleteFile.rejected, (state, action) => {
			state.error = action.error.message || null;
		});
	},
});

export default FileManagerSlice.reducer;
